import ExternalSVG from '../external-svg.js';
// TODO: this is a circular dependency
import useConfiguration from '~/configuration/use-configuration.js'; // eslint-disable-line import/no-extraneous-dependencies

const createURL = (CDN_URL, SVGBasePath, filename) => `${CDN_URL}${SVGBasePath}/${filename}`;

// Logos for Przelewy24 in Poland
export const LogoP24Color = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return <ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'logo-p24-color.svg')} />;
};

export const LogoP24White = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return <ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'logo-p24-white.svg')} />;
};

// LOGOS MOJEID / IMOJE POLAND
export const LogoGetin = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return <ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'imoje-banks/logo-getin.svg')} />;
};

// ADYEN IDEAL SVG LOGOS
export const LogoAdyenIdealColor = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return <ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'ADYEN_IDEAL_COLOR.svg')} />;
};

export const LogoAdyenIdealBW = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return <ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'ADYEN_IDEAL_BW.svg')} />;
};

export const LogoBankSelectPolski = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return (
		<ExternalSVG
			className={className}
			url={createURL(CDN_URL, SVGBasePath, 'mojeid-banks-select/logo-polski.svg')}
		/>
	);
};

export const LogoING = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return <ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'logo-ing.svg')} />;
};

export const LogoBankSelectInteligo = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return <ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'imoje-banks/logo-inteligo.svg')} />;
};

export const LogoBankSelectSGB = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return (
		<ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'mojeid-banks-select/logo-sgb.svg')} />
	);
};

export const LogoBankSelectBOS = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return (
		<ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'mojeid-banks-select/logo-bos.svg')} />
	);
};

export const LogoBankSelectMBank = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return (
		<ExternalSVG
			className={className}
			url={createURL(CDN_URL, SVGBasePath, 'mojeid-banks-select/logo-mBank.svg')}
		/>
	);
};

export const LogoBankSelectBNP = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return (
		<ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'mojeid-banks-select/logo-bnp.svg')} />
	);
};

export const LogoBankSelectBSPB = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return (
		<ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'mojeid-banks-select/logo-bspb.svg')} />
	);
};

export const LogoBankSelectBPS = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return (
		<ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'mojeid-banks-select/logo-bps.svg')} />
	);
};

export const LogoMojeId = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return <ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'logo-mojeid.svg')} />;
};

export const LogoCreditAgricole = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return (
		<ExternalSVG
			className={className}
			url={createURL(CDN_URL, SVGBasePath, 'imoje-banks/logo-creditagricole.svg')}
		/>
	);
};

export const LogoBankSelectPekao24 = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return <ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'imoje-banks/logo-peka024.svg')} />;
};

export const LogoAlior = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return <ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'imoje-banks/logo-alior.svg')} />;
};

export const LogoSantanderBank = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return (
		<ExternalSVG
			className={className}
			url={createURL(CDN_URL, SVGBasePath, 'mojeid-banks-select/logo-santander.svg')}
		/>
	);
};

export const LogoMillennium = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return (
		<ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'imoje-banks/logo-millennium.svg')} />
	);
};

export const LogoKasaBank = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return (
		<ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'mojeid-banks-select/logo-kasa.svg')} />
	);
};

export const LogoMtransfer = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return (
		<ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'imoje-banks/logo-mtransfer.svg')} />
	);
};

export const LogoBzwbk = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return <ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'imoje-banks/logo-bzwbk.svg')} />;
};

export const LogoIpko = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return <ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'imoje-banks/logo-ipko.svg')} />;
};

export const LogoNoble = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return <ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'imoje-banks/logo-noble.svg')} />;
};

export const LogoIdeabank = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return <ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'imoje-banks/logo-ideabank.svg')} />;
};

export const LogoPbs = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return <ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'imoje-banks/logo-pbs.svg')} />;
};

export const LogoCiti = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return <ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'imoje-banks/logo-citi.svg')} />;
};

export const LogoBos = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return <ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'imoje-banks/logo-bos.svg')} />;
};

export const LogoBnpparibas = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return (
		<ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'imoje-banks/logo-bnpparibas.svg')} />
	);
};

export const LogoPocztowy = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return <ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'imoje-banks/logo-pocztowy.svg')} />;
};

export const LogoPlusbank = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return <ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'imoje-banks/logo-plusbank.svg')} />;
};

export const LogoBs = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return <ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'imoje-banks/logo-bs.svg')} />;
};

export const LogoEnvelo = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return <ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'imoje-banks/logo-envelo.svg')} />;
};

export const LogoBlikColor = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return <ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'imoje-banks/logo-blik.svg')} />;
};

// END LOGOS MOJEID / IMOJE POLAND

// used in paypal-subscription-prompt-modal.js
export const LogoPaypalBW = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return <ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'logo-paypal-new.svg')} />;
};

// used in packages/mobile-core/src/components/authentication/transaction-link/index.js
export const LogoTransactionLink = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return (
		<ExternalSVG
			className={className}
			url={createURL(CDN_URL, SVGBasePath, 'logo-transaction-link.svg')}
			lazy={false}
		/>
	);
};

export const LogoSwish = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return <ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'logo-swish.svg')} />;
};

export const LogoDefaultBank = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return <ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'logo-default-color.svg')} />;
};

export const LogoDefaultBankBW = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return <ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'logo-default-bank.svg')} />;
};

export const LogoPaypalColor = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return <ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'logo-paypal-color.svg')} />;
};

export const LogoPaypal = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return <ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'logo-paypal.svg')} />;
};

export const LogoTrustly = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return <ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'logo-trustly.svg')} />;
};

export const LogoTrustlyColor = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return <ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'logo-trustly-color.svg')} />;
};

export const LogoSwishColor = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return <ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'logo-swish-color.svg')} />;
};

export const LogoVisa = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return <ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'logo-visa.svg')} />;
};

export const LogoVisaColor = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return <ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'logo-visa-color.svg')} />;
};

export const LogoCreditCard = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return <ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'logo-credit-card-bw.svg')} />;
};

export const LogoCreditCardColor = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return <ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'logo-creditcard-color.svg')} />;
};

export const LogoMobilePay = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return <ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'logo-mobilepay.svg')} />;
};

export const LogoMobilePayColor = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return <ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'logo-mobilepay-color.svg')} />;
};

export const LogoMasterCard = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return <ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'logo-mastercard.svg')} />;
};

export const LogoMasterCardColor = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return <ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'logo-mastercard-color.svg')} />;
};

export const LogoKlarnaColor = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return <ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'logo-klarna-color.svg')} />;
};

export const LogoKlarna = ({ className }) => {
	const { CDN_URL, SVGBasePath } = useConfiguration();
	return <ExternalSVG className={className} url={createURL(CDN_URL, SVGBasePath, 'logo-klarna.svg')} />;
};
